export const siteInfo = {
  name: "HIGA Automation",
  companyName: "HIG Automation India Private Limited",
  legalName: "HIG Automation India Private Limited",
  shortName: "HIG Automation",

  tagline: "Smarter Automation. Precision Fabrication. Reliable Service.",
  motto: "Heat · Integrate · Govern · Automate",

  url: "https://higautomation.com",
  website: "https://higautomation.com",
  logo: "/higa-logo.png",

  phone: "+91 98963 14582",

  // Displayed in the website header and general contact information
  email: "info@higautomation.com",

  // Receives Request a Quote enquiries
  salesEmail: "sales@higautomation.com",

  supportEmail: "info@higautomation.com",

  address: "Plot No. 121, Kaluwas Road, Rewari, Haryana — 123401",

  founded: "June 2025",

  googleMaps:
    "https://maps.google.com/?q=Plot+No.+121+Kaluwas+Road+Rewari+Haryana+123401",

  workingHours: {
    weekdays: "Monday – Saturday",
    timing: "9:00 AM – 6:30 PM",
    timezone: "IST",
  },

  social: {
    linkedin: "",
    facebook: "",
    instagram: "",
    youtube: "",
  },

  analytics: {
    googleAnalytics: "G-W2PEMCCN7C",
  },

  searchConsole: {
    verification: "z86nPImLWAvWKUIOl2Kz-bEU2DmPOmVEgynCI0M2Qhg",
  },
};